<script setup lang="ts">
import { computed } from 'vue';
import { Tag } from '@pkg/ui/components/ui/tag';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const CLOCK_ICON_SRC = '/images/clock.svg';

const props = withDefaults(defineProps<{
  timeString?: string;
  timeTag?: string;
  availableBag?: boolean;
  renderCollectionTimeInline?: boolean;
  soldOutText?: string;
  timeObject?: {
    pickupWindowLabel: string;
    pickupWindowStartTime: string;
    pickupWindowEndTime: string;
  };
}>(), {
  timeString: '',
  timeTag: '',
  soldOutText: '',
  timeObject: undefined,
  renderCollectionTimeInline: false,
});

const timeTagText = computed(() => {
  return props.timeTag ? t(props.timeTag.toString().toLowerCase()) : '';
});

</script>

<template>
  <p class="surprise-bag-collection-time" :class="{ 'surprise-bag-collection-time--inline': renderCollectionTimeInline }">
    <img v-if="!renderCollectionTimeInline" :src="CLOCK_ICON_SRC" alt="Clock icon">
    <template v-if="availableBag">
      <template v-if="timeObject">
        <span v-if="timeObject.pickupWindowLabel">{{ timeObject.pickupWindowLabel }}</span>
        <time :datetime="timeObject.pickupWindowStartTime">{{ timeObject.pickupWindowStartTime }}</time>
        <span aria-hidden="true">–</span>
        <time :datetime="timeObject.pickupWindowEndTime">{{ timeObject.pickupWindowEndTime }}</time>
      </template>
      <span v-else>{{ timeString }}</span>
    </template>
    <span v-else>{{ soldOutText }}</span>
    <Tag v-if="timeTagText && availableBag && !renderCollectionTimeInline" :text="timeTagText" class="surprise-bag-collection-time__tag" />
  </p>
</template>

<style scoped>
@import '~/assets/css/mixins/_mixins.index.pcss';

.surprise-bag-collection-time {
  display: flex;
  align-items: center;
  gap: theme('spacing.8');
  padding-top: theme('spacing.16');
  word-break: keep-all;

  &__tag {
    background-color: theme('colors.primary.30');
    color: theme('colors.white');
    text-transform: capitalize;
    word-break: keep-all;
  }

  &--inline {
    display: inline;
  }
}
</style>
